import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {
  Eye,
  Trash2,
  Edit,
} from 'lucide-react';
import { formatCurrency } from '../utils/formatUtils';

const ReportTable = ({
  title,
  data,
  columns,
  loading,
  emptyMessage,
  onAdd,
  onView = null,
  onEdit,
  onDelete,
  setError
}) => {
  const navigate = useNavigate();

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200">
      <div>
        {loading ? (
          <div className="flex justify-center items-center h-64">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
          </div>
        ) : (
          <table className="w-full divide-y divide-gray-200">
            <thead>
              <tr className="text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50">
                {columns.map(column => (
                  <th key={column.key} className={column.className || "px-4 sm:px-6 py-3"}>{column.label}</th>
                ))}
                {/* Only add Actions header if no custom actions column */}
                {!columns.some(col => col.key === 'actions') && (
                  <th className="px-4 sm:px-6 py-3 text-right">Actions</th>
                )}
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {data.length > 0 ? (
                data.map(item => (
                  <tr key={item.id} className="hover:bg-gray-50">
                    {columns.map(column => (
                      <td key={column.key} className="px-4 sm:px-6 py-4">
                        {column.render
                          ? column.render(item)
                          : column.format
                          ? column.format(item[column.key])
                          : column.key.toLowerCase().includes('amount')
                          ? formatCurrency(item[column.key])
                          : item[column.key]}
                      </td>
                    ))}
                    {/* Only add default actions if no custom actions column */}
                    {!columns.some(col => col.key === 'actions') && (
                      <td className="px-4 sm:px-6 py-4 whitespace-nowrap text-right text-sm">
                        <div className="flex justify-end space-x-2">
                          <button
                            onClick={() => onView ? onView(item) : navigate(`/dashboard/expense-reports/${item.id}`)}
                            className="text-gray-600 hover:text-gray-900"
                            title="View"
                          >
                            <Eye className="h-4 w-4" />
                          </button>
                          <button
                            onClick={() => onEdit(item)}
                            className="text-blue-600 hover:text-blue-900"
                            title="Edit"
                          >
                            <Edit className="h-4 w-4" />
                          </button>
                          <button
                            onClick={() => onDelete(item)}
                            className="text-red-600 hover:text-red-900"
                            title="Delete"
                          >
                            <Trash2 className="h-4 w-4" />
                          </button>
                        </div>
                      </td>
                    )}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={columns.length + (!columns.some(col => col.key === 'actions') ? 1 : 0)} className="px-6 py-12 text-center">
                    {emptyMessage}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default ReportTable;
